import { put, takeEvery } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { createNewAd } from "./helpers/createItems";
import { push } from "connected-react-router";




function* addItem({payload}) {
    yield createNewAd(payload.itemData)

    if(payload.closePagePath)  {
        yield put(push(payload.closePagePath))
    }
}


export function* watchAddAd() {
    try {
        yield takeEvery(actionTypes.ADS_REQUEST_ADD_ITEM, addItem)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}